var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"container mt-5",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }